<template>
    <div>
        <!-- ALERT MESSAGE STARTS -->
        <transition name="fade">
            <div
                class="alert alertmessage"
                :class="{
                    'alert-warning': alert.isError,
                    'alert-success': !alert.isError
                }"
                v-if="alert.showAlert"
            >
                <strong v-if="alert.isError">Error!</strong>
                <strong v-else>Success!</strong>

                <br /><br />
                <p v-for="message in alert.alertMessage">♢ {{ message }}</p>
            </div>
        </transition>
        <!-- ALERT MESSAGE ENDS -->

        <!--Filter Option-->
        <!-- <b-card title="User Management" :sub-title="infoPopup.title" class="mb-4">
            <hr>
            <b-form @submit.prevent="vue_universal_table.update++">
                <b-form-row>
                    <b-form-group label="Username / Name" class="col-md-4 dateCss" style="height:42px" >
                        <b-form-input v-model="filter.search" placeholder="Type username / name"/>
                    </b-form-group>
                    <div class="col-md-4 offset-md-4" style="display: flex; flex-direction: column-reverse;">
                        <b-btn type="button" variant="primary" @click="vue_universal_table.update++" style="height: 42px;"><i class="fa fa-filter"></i>&nbsp;&nbsp;Search</b-btn>
                    </div>
                </b-form-row>
            </b-form>
        </b-card> -->
        <div class="row">
            <div class="col-lg-4 col-12 mt-1 mb-1">
                <div class="title flex-middle h-100">
                    <h3>Unit Management</h3>
                </div>
            </div>
            <div class="col-lg-6 offset-lg-2 col-12 flex-middle">
                <div class="row w-100">
                    <div class="col-lg-6 col-12 mt-1 mb-1">
                        <div class="row w-100">
                            <div class="col-10" style="padding-right: 0">
                                <input
                                    type="text"
                                    class="form-control"
                                    style="
                                        border: none;
                                        border-radius: 8px 0px 0px 8px;
                                    "
                                    v-model="filter.search"
                                    placeholder="Search"
                                />
                            </div>
                            <div
                                class="col-1 bg-white"
                                style="
                                    padding-left: 0;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    border-radius: 0px 4px 4px 0px;
                                "
                            >
                                <i class="fa fa-search fa-lg"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-12 mt-1 mb-1 flex-middle">
                        <button
                            type="button"
                            @click="modal.modify = true;"
                            class="btn btn-green w-100"
                            style="height: 43px"
                            
                        >
                            Add New Series
                        </button>
                    </div>
                    <div class="col-lg-3 col-12 mt-1 mb-1 flex-middle">
                        <button
                            type="button"
                            @click="downloadUserExcel"
                            class="btn w-100"
                            style="height: 43px"
                        >
                            Download Excel
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="mb-4 p-15 card mt-2"
            style="border-color: #fff; border-radius: 8px"
        >
            <vue-universal-table
                :api_url="'/api/list-series'"
                :filter="filter"
                :update="vue_universal_table.update"
                :fields="vue_universal_table.fields"
                :buttons="vue_universal_table.buttons"
                :sort_by="'user_id'"
                :sort_order="'DESC'"
                :button_title="'Action'"
                @onEdit="editUserClicked"
                @onDelete="deleteUser"
                @onAddUser="viewModal.newUser = true"
            ></vue-universal-table>
        </div>

        <!-- <div v-if="viewModal.newUser">
            <new-user-modal
                @closeModal="viewModal.newUser = false"
                @triggerAlert="triggerAlert"
            ></new-user-modal>
        </div>

        <div v-if="viewModal.editUser">
            <edit-user-modal
                :user_id="user_id_for_edit"
                @closeModal="viewModal.editUser = false"
                @triggerAlert="triggerAlert"
            ></edit-user-modal>
        </div> -->
        <modifyUnit 
            v-if="modal.modify"
            @closeModal="modal.modify = false;data = null"
            @triggerAlert="triggerAlert"
            :data="data"
        />
    </div>
</template>

<script>
// import newUserModal from './children/newUserModal';
// import editUserModal from './children/editUserModal';
import debounce from 'debounce';
import modifyUnit from './children/modifyUnit.vue';

export default {
    name: 'user-management',
    metaInfo: {
        title: 'User Management'
    },
    data() {
        return {
            infoPopup: 'Test',
            alert: {
                showAlert: false,
                isError: false,
                alertMessage: []
            },
            filter: {
                search: ''
            },
            vue_universal_table: {
                update: 0,
                fields: [
                    {
                        title: 'Series',
                        variable: 'series'
                    },
                    {
                        title: 'Type Code',
                        variable: 'type_code'
                    },
                    {
                        title: 'Color',
                        variable: 'color_desc'
                    },
					{
                        title: 'Color Code',
                        variable: 'color_code'
                    },
                    {
                        title: 'Name',
                        variable: 'commercial_name'
                    },
                    {
                        title: 'Status',
                        variable: 'status',
                        style: '',
                        style_condition: {
                            Active: 'color: #00B14B;',
                            Inactive: 'color: red;'
                        }
                    },

                    {
                        title: 'Foto',
                        variable: 'url_image',
                        is_image : true
                    }
                ],
                buttons: [
                    {
                        title: 'Edit',
                        class: 'fas fa-pen btn-outline-black'
                    }
                ],
                special_buttons: ['addUser'],
                process_data: `for (var i in data) data[i].permissionString = data[i].permission ? data[i].permission.join(", ") : '-'`
            },
            viewModal: {
                newUser: false,
                editUser: false
            },
            data : null,
            modal : {
                modify : false
            }
        };
    },
    components: {
        // newUserModal,
        // editUserModal
        modifyUnit
    },
    mounted() {},
    watch: {
        'filter.search': function () {
            this.debounceMethod('test', this);
        }
    },
    methods: {
        debounceMethod: debounce((value, vm) => {
            vm.vue_universal_table.update++;
        }, 1000),
        closeAllModal() {
            var keys = Object.keys(this.viewModal);
            for (var i = 0; i < keys.length; i++) {
                this.viewModal[keys[i]] = false;
            }
            this.vue_universal_table.update++;
        },
        deleteUser(user_id) {
            let vm = this;
            var user = { id: user_id };
            this.$swal
                .fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085D6',
                    cancelButtonColor: '#D33',
                    confirmButtonText: 'Delete'
                })
                .then((result) => {
                    console.log(result);
                    if (result.value) {
                        vm.$http
                            .delete('/api/delete-user', { data: user })
                            .then((res) => {
                                console.log(res);
                                vm.vue_universal_table.update++;
                                vm.$swal.fire(
                                    'Deleted',
                                    'User has been successfully removed',
                                    'success'
                                );
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                });
        },
        editUserClicked(dataEdit) {
            dataEdit = this.isJsonString(dataEdit) ? JSON.parse(dataEdit) : dataEdit
            this.data = dataEdit;
            this.modal.modify = true;
        },
		async downloadUserExcel () {
			// this.triggerAlert(true , 'Fitur Belum Tersedia')
			try {
                let url = '/api/download-series'
                if(this.filter.search) url += '?search=' + this.filter.search
				let response = await this.$http.get(url)

				// console.log(response.data.data)
				this.exportExcel(response.data.data , 'Unit List')
			}
			catch(err) {
				this.triggerAlert(true , 'Download Failed !')
				console.log(err)
			}
		},
        triggerAlert(isError, alertMessage) {
            //Boolean, Array
            let vm = this;

            if (!isError) this.closeAllModal(); //SPECIAL FOR THIS PAGE (CLOSE MODAL AND REFRESH DATA)

            vm.alert.isError = isError;
            vm.alert.alertMessage.length = 0;
            vm.alert.alertMessage =
                this.alert.alertMessage.concat(alertMessage);

            vm.alert.showAlert = true;
            setTimeout(() => {
                vm.alert.showAlert = false;
            }, 5000);
        }
    }
};
</script>

<style>
/* ALERT MESSAGE STARTS */
.alertmessage {
    position: fixed;
    top: 10%;
    left: 47.5%;
    z-index: 9999;
    width: 300px;
    text-align: center;
}
.alertmessage strong {
    font-size: 150%;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
/* ALERT MESSAGE ENDS */

.btn-primary {
    background-color: #348fe2 !important;
}
</style>

<style scoped>
.form-control:focus {
    box-shadow: none;
}

.flex-middle {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    width: 100%;
}
</style>
